module.exports = __webpack_public_path__ + "img/kyber.6105a9fe.png";